import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';
import logo from '../../assets/bch-white.png';

const NAV_ITEMS = [
  { path: '/dashboard', icon: 'fa-home', label: 'Dashboard' },
  { path: '/vehicles', icon: 'fa-car', label: 'Vehicles' },
  { path: '/parameter', icon: 'fa-sliders-h', label: 'Parameter' },
];

function Sidebar({ collapsed, onToggle }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className={`sidebar${collapsed ? ' collapsed' : ''}`} id="sidebar">
      <div className="sidebar-header">
        <img src={logo} alt="Beachcomber" className="sidebar-logo" />
        <button className="toggle-btn" onClick={onToggle} aria-label="Toggle sidebar">
          <i className="fas fa-bars"></i>
        </button>
      </div>
      <ul className="sidebar-menu">
        {NAV_ITEMS.map(({ path, icon, label }) => (
          <li
            key={path}
            className={pathname === path ? 'active' : ''}
            onClick={() => navigate(path)}
          >
            <i className={`fas ${icon}`}></i>
            <span className="menu-text">{label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Sidebar;
